import { OverflowTooltip } from '@/components/ui/OverflowTooltip';
import { formatLocalDate } from '@/lib/utils/common/dateFormats';

export const DateCell = ({ value }: { value?: Date }) =>
  value && <OverflowTooltip>{formatLocalDate(value)}</OverflowTooltip>;
